import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { filmsApi } from "../api/filmsApi";
import { Timer_Entity } from "../../kronos-kit";

const timersAdapter = createEntityAdapter<Timer_Entity>();
const initialState = timersAdapter.getInitialState();

export const timerEndpoints = filmsApi.injectEndpoints({
  endpoints: (build) => ({
    getTalentTimers: build.query<EntityState<Timer_Entity>, number>({
      query: (id) => `talents/${id}/timers`,
      transformResponse: (responseData: Timer_Entity[]) => {
        return timersAdapter.setAll(initialState, responseData);
      },
      providesTags: ["timers"],
    }),
  }),
});

export const { useGetTalentTimersQuery } = timerEndpoints;

export default timerEndpoints;
